export default "__VITE_ASSET__C4NuQ8Bh__"